import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { WORKS } from "../data";
import { BeforeAfter } from "./BeforeAfter";

export const Gallery = () => {
  const [idx, setIdx] = useState(null);
  const w = idx !== null ? WORKS[idx] : null;
  const go = (d) => setIdx((idx + d + WORKS.length) % WORKS.length);

  return (
    <section id="trabalhos" data-testid="gallery-section" className="section">
      <div className="wrap">
        <span className="eyebrow">Trabalhos realizados</span>
        <h2 className="h2 mt-5">Obra feita.</h2>
        <div className="gallery-grid mt-14">
          {WORKS.map((it, i) => (
            <button key={it.id} data-testid={`gallery-item-${i}`} onClick={() => setIdx(i)} className={`gallery-item g-${i}`}>
              <img src={`/img/${it.id}-sm.webp`} alt={it.title} loading="lazy" decoding="async" width="800" height="600" />
              <div className="gallery-cap">
                <span className="chip chip-red">{it.tag}</span>
                <h3 className="font-display uppercase text-xl font-bold mt-3 text-left">{it.title}</h3>
              </div>
            </button>
          ))}
        </div>
        <BeforeAfter />
      </div>
      <Dialog open={idx !== null} onOpenChange={(o) => !o && setIdx(null)}>
        <DialogContent data-testid="lightbox-modal" className="max-w-5xl bg-[var(--bg)] border-[var(--line)] text-white p-0 overflow-hidden">
          {w && (
            <div>
              <div className="relative bg-black">
                <img src={`/img/${w.id}-lg.webp`} alt={w.title} decoding="async" className="w-full max-h-[70vh] object-contain" data-testid="lightbox-image" />
                <button onClick={() => go(-1)} data-testid="lightbox-prev-btn" className="lb-nav left-3" aria-label="Anterior"><ChevronLeft /></button>
                <button onClick={() => go(1)} data-testid="lightbox-next-btn" className="lb-nav right-3" aria-label="Seguinte"><ChevronRight /></button>
              </div>
              <div className="p-6">
                <span className="chip chip-red">{w.tag}</span>
                <DialogTitle className="font-display uppercase text-2xl mt-3" data-testid="lightbox-title">{w.title}</DialogTitle>
                <DialogDescription className="text-[var(--muted)] mt-2">{w.text}</DialogDescription>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};
